export default __webpack_public_path__ + "static/media/yt_nibiru-ep5.72fde378.jpg";